@if (!item().hidden) {
  <li class="nav-item coded-menu-caption">
    <label>{{ item().title | translate }}</label>
  </li>
  @for (items of item().children; track $index) {
    @if (items.type === 'collapse') {
      <app-menu-collapse-compact [item]="items" [parentRole]="item().role" />
    } @else if (items.type === 'item') {
      <app-menu-item-compact [item]="items" [parentRole]="item().role" />
    }
  }
}
